<template>
    <div class="lineData" :class="{ bgPicter: !isNodata }">
        <v-chart
                ref="lineBrand"
                :options="lineData"
                id="echart1"
                auto-resize
        ></v-chart>
        <div
                class="no-chart-data"
                style="color:#D3D3D3;font-size:20px;"
                v-show="isNodata"
        >
            Temporarily no data
        </div>
    </div>
</template>

<script>
let setOption = () => {
  let lineColor = ['#5C89FF']
  let result = []
  for (let i = 0; i < lineColor.length; i++) {
    result.push({
      type: 'line',
      smooth: true,
      itemStyle: {
        normal: {
          lineStyle: {
            color: lineColor[i],
            width: 2 //设置线条粗细
          }
        }
      }
    })
  }
  return result
}

export default {
  name: 'lineData',
  props: ['echartsData', 'isNodata'],
  data () {
    return {
      lineData: {},
      myChart: ''
    }
  },
  mounted () {
    this.myChart = this.$refs.lineBrand.chart
    let myChart = this.myChart
    window.addEventListener('resize', () => {
      this.myChart.resize()
    })
    this.setOptions()
    //下钻
    myChart.getZr().on('click', (params) => {
      var pointInPixel = [params.offsetX, params.offsetY]
      if (myChart.containPixel('grid', pointInPixel)) {
        //此处添加具体执行代码
        var pointInGrid = myChart.convertFromPixel(
          {seriesIndex: 0},
          pointInPixel
        )
        //X轴序号
        var xIndex = pointInGrid[0]

        //获取当前图表的option
        var op = myChart.getOption()

        //获得图表中我们想要的数据
        var month = op.xAxis[0].data[xIndex]
        if (month !== '') {
          sessionStorage.setItem('month', month)
          this.$router.push({
            path: '/brand/BigFrame/logoDetail/Detail/LyricSearch',
            query: {
              id: sessionStorage.getItem('id'),
              time: month
            }
          })
        }
      }
    })
  },
  methods: {
    setOptions () {
      let echarts = require('echarts')
      let newResultData = this.$lodash.cloneDeep(
        JSON.parse(JSON.stringify(this.echartsData))
      )
      if (newResultData && newResultData.length > 0) {
        newResultData[1].map((item, index) => {
          item = Object.assign(item, setOption()[index])
        })
        this.lineData = this.getOptions(newResultData)
      }
      this.myChart = echarts.init(document.getElementById('echart1'))
    },
    getOptions (seriesData) {
      let xAxisVal = JSON.parse(JSON.stringify(seriesData[0]))
      let AseriesData = JSON.parse(JSON.stringify(seriesData[1]))

      return {
        toolbox: {
          //工具栏(下载)
          feature: {
            saveAsImage: {
              show: true && !sessionStorage.getItem('noSaveAsImage'),
              title: 'Save as picture' //提示文字设置
            }
          },
          right: '5%', //下载图标距右边框5%
          top: '-2%'
        },
        //title: {
        //text: 'Trend Analysis of Brand Volume',
        //show: this.echartsData[0].length === 0,
        // textStyle: {
        //     color: "LightGrey",
        //     fontSize: 20
        // },
        //left: "center",
        //top: "center"
        //},
        title: {
          text: 'Trend Analysis of Brand Volume',
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#DFDFDF',
                width: 1
              }
            },
            axisLabel: {
              fontSize: 12,
              fontFamily: 'RCR',
              textStyle: {
                color: '#00000',
                fontWeight: 1
              }
            },
            data: xAxisVal || []
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#DFDFDF',
                width: 1
              }
            },
            splitLine: {
              show: false
            },
            // y axios 字体设置
            axisLabel: {
              fontSize: 12,
              fontFamily: 'RCR',
              textStyle: {
                color: '#00000',
                fontWeight: 1
              }
            }
          }
        ],
        series: AseriesData || []
      }
    }
  },
  watch: {
    echartsData () {
      this.setOptions()
    }
  }
}
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }

    .lineData {
        position: relative;
    }

    .lineData .no-chart-data {
        width: 300px;
        font-size: 25;
        font-weight: 600;
        position: absolute;
        left: 60%;
        right: 50%;
        transform: translate(-50%, -588%);
    }
</style>
